export * as WalletsApprovalPolicy from './ApprovalPolicy'
